export const LOADING_PUSH = "LOADING_PUSH";
export const GET_PUSH_LIST = "GET_PUSH_LIST";
export const REMOVE_PUSH = "REMOVE_PUSH";
export const ADD_PUSH = "ADD_PUSH";
export const UPDATE_PUSH = "UPDATE_PUSH";
export const GET_PUSH_ID = "GET_PUSH_ID";